module.exports = __webpack_public_path__ + "media/images/home/review-likes-0c7960bd46531b15df98a71f6966f4e1.png";